import stockList, { loadResults } from './stock-list.js';
import SymbolForm from '../includes/symbol-form.js';

let section;
let form;

function toggleScreenMode(toggled = false) {
	$('.covered-calls-screen-expiration_date_weekly').toggleClass('hidden', toggled);
	$('.covered-calls-screen-expiration_date_monthly').toggleClass('hidden', !toggled);
}

function setSymbol(symbol) {
	document.getElementById('covered-calls-stock').classList.toggle('invisible', !symbol);
	document.getElementById('covered-calls-stock-symbol').textContent = symbol;

	history.pushState({ symbol }, null, `/covered-calls/screen${(symbol ? '/' : '') + symbol}`);

	SymbolForm.select({ symbol });

	// Set the symbol value as JSON-encoded string to match PHP template handling
	form.set('symbol', JSON.stringify(symbol));
}

function symbolFormCallback(stock) {
	setSymbol(stock.symbol);
}

function onResultsLoad(section) {
	const links = section[0].getElementsByClassName('covered-calls-symbol');

	for (const link of links) {
		link.addEventListener('click', function(e) {
			e.preventDefault();

			setSymbol(link.dataset.symbol);
		})
	}
}

export default async function(res, target) {
	section = target;

	form = (await stockList(res, target, { symbolFormCallback, onResultsLoad })).formObj;

	form.setCallback('expiration_date_type', 'update', toggleScreenMode);
	form.setCallback('expiration_date_type', 'set', () => loadResults());

	window.addEventListener('popstate', function({ state }) {
		setSymbol(state.symbol);
	});

	document.getElementById('covered-calls-stock-remove').addEventListener('click', function(e) {
		e.preventDefault();

		setSymbol('');
	});
};
